import { render, staticRenderFns } from "./UberEatsIntegrationStatus.vue?vue&type=template&id=f5c27ea0"
import script from "./UberEatsIntegrationStatus.vue?vue&type=script&lang=ts"
export * from "./UberEatsIntegrationStatus.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports